import { ref } from 'vue'
import { apiFetch } from '../../services/api'

// Live (API-backed) validation for an audience block definition — e.g.
// checking a configured Salesforce report actually has the columns a
// Find block needs.
export function useBlockValidation() {
  const validating = ref(false)
  const validationError = ref('')
  const validationSuccess = ref('')

  function reset() {
    validating.value = false
    validationError.value = ''
    validationSuccess.value = ''
  }

  async function validate(blockType: string, block: Record<string, any>, slot: string = 'produce') {
    validating.value = true
    validationError.value = ''
    validationSuccess.value = ''

    try {
      const resp: any = await apiFetch('/audiences/blocks/validate', {
        method: 'POST',
        body: { block_type: blockType, slot, full: true, block },
      })
      if (resp.valid) {
        validationSuccess.value = resp.info?.[0]?.message || 'Configuration looks good.'
      } else {
        validationError.value = resp.errors?.[0]?.message || 'Validation failed.'
      }
    } catch (e: any) {
      validationError.value = e?.message || 'Could not validate configuration.'
    } finally {
      validating.value = false
    }
  }

  return { validating, validationError, validationSuccess, validate, reset }
}
